var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _ellipse, _rect, _rect2, _rect3, _rect4, _path27, _g, _rect5, _rect6, _line, _line2, _line3, _line4, _line5, _line6, _line7, _path28, _line8, _line9, _line0, _line1, _line10, _line11, _path29, _circle, _path30, _path31, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path32, _path33, _path34, _path35, _path36, _path37, _rect18, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g2, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _circle2, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _g3, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _ellipse2, _path82, _polygon, _polygon2, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ebf8a77a-edff-4dc3-b5b4-de0e5991af45",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1084.99,
    height: 822.75,
    viewBox: "0 0 1084.99 822.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "3dbb7376-c47c-4ca7-b468-761ae3cf9a96",
    x1: 609.82,
    y1: 674.04,
    x2: 609.82,
    y2: 135.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9599d617-6377-49c4-b753-a452dc901e54",
    x1: 629.86,
    y1: 815.18,
    x2: 629.86,
    y2: 282.75,
    gradientTransform: "translate(-20.86 21.29) rotate(-2.2)",
    xlinkHref: "#3dbb7376-c47c-4ca7-b468-761ae3cf9a96"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "setup analytics") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271.64,47s-3.77,14.71,22.58,56.29,24.52,47.47,23,59.36-1.43,18.4-16.74,33c0,0-45.87,15.06-52,24.45s10.13,43.53,10.13,43.53,15.62,41.47-40.47,57.38c0,0-43.89.06-56.06,9.73,0,0,4.71-16.83-9.93-41.58s5.53-48.88,5.53-48.88,16.24-8.94,26.55-9.63,13.58-5.41,6.95-17.26c0,0-9.59-5-22.87,5.71s-23.2,18.34-34.77,17.44-28.07-5.78-38.9-27.19S78.11,157.67,70,143.85,57.5,127,57.5,127s10.25,7.78,45.64-18.63S157,93.26,157,93.26s28.44,7.64,33,57.79c0,0,8.27,47.79,25.08,18.84,0,0-5.69-16.3-17.06-40.3S217.08,83,239.36,75.44,271.64,47,271.64,47Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#4b59f7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.49,137.59l-.1-.25c7-2.92,39.29,14.57,65.11,29.76l-.14.23C116.94,145.91,93.9,135.35,88.49,137.59Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#444053"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.83,167l.28-.15C173.73,179,198.47,194.42,217,206.94c1.76,1.19,3.59,2.37,5.46,3.48l-.29.47c-1.87-1.12-3.71-2.3-5.48-3.5C198.18,194.88,173.44,179.14,152.83,167Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#444053"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221.63,210.59l.46-.36c37.17,22.31,89.46,17,89.92,17l-5.77,6.55C305.78,233.81,259.06,233.05,221.63,210.59Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#444053"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M257.68,80.61s-12.17,33.89-2.92,57.77-10,83.05-10,83.05-6.39,24.89-16.67,31.11c0,0-14.91,18.51-23.65,20.63s-28.84,20.9-28.31,31.29",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M274.14,83s-8.58,17.4-21.35,17.25",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M291.34,105.62s-5.19,23.93-37.34,30.62",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M304.73,141.28S289.6,165.52,257,162.57",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M301.9,186.69s-28.47,18.65-50,8.41",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M237.56,83S245,98.74,253.23,94",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M210.32,106.91s10,21.12,41.29,17.41",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M207.3,138.67s27.52,16.72,49.84,12.19",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M221.79,172.52s21.78,17.37,32,13.38",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M216.69,185.47s5.89,18.25.1,21.7",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M197.4,212.84s11.23-11.15,8.1-13.2",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M176.77,120.22s9.83,46.69-2.94,59.29",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M135.67,231.31s44.49-28.57,48.37-45.45",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.9,211.17s41.85-19.51,53.2-38.2",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138,105.26s20.25,33.78,7.6,57.42",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.25,180.49s31-12.55,37.27-24.64",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M102.79,115.56s10.37,19.12,5.54,27.43",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23,228.68s28-3.75,31,3.56",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M255,286.06s-1.51-30.62-19-42.46",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M178.22,241s29.39,3.47,39.78,22.64",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M227.51,308.27s4.54-22.43-16.93-38.29",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M157.05,268.1s24.38-1.25,37.44,10.34",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M190.65,312.44s-2.28-17.8-8.64-21.17",
    transform: "translate(-57.5 -38.62)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M568.79,236c-54.87,27.61-114.88,39.65-173.39,48.93s-117.57,16.43-175.23,35.83c-37.08,12.48-76.27,32.69-94.55,64.09C108,415,114.51,447.15,123.83,475.17c7,21.07,16,42.39,35.16,55.27,13.32,8.94,30.61,13.13,45.13,20.74,50.51,26.45,58.7,88.49,50.56,145.56-3.82,26.77-10.38,53.89-10.29,80.13s7.66,52.24,28.48,67.74c20.64,15.36,51.63,18.48,82,16,61.71-5,123.76-30.59,182.86-58.09C668.59,741.65,793.94,669.08,919,596.69c46.26-26.79,92.73-53.71,135.32-85.44,23.65-17.62,47-37.86,57.92-62.08,13.91-30.74,3.3-64.23-24.74-78.06-47-23.2-125.58,7.39-166.11-22.91C899,331.52,896.08,301,899.73,272.35c7.82-61.56,40.14-129.41,15.47-181.5C898.26,55.07,853.68,34.25,805,39.4c-51,5.4-107.52,38.93-122.72,84.13C666.66,170.08,617.24,211.57,568.79,236Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#4b59f7",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 642.84,
    cy: 761.32,
    rx: 100.11,
    ry: 24.73,
    fill: "#4b59f7",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 134.66,
    y: 135.71,
    width: 950.33,
    height: 538.33,
    rx: 12.49,
    ry: 12.49,
    fill: "url(#3dbb7376-c47c-4ca7-b468-761ae3cf9a96)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 136.17,
    y: 143.28,
    width: 947.42,
    height: 528.97,
    rx: 12.49,
    ry: 12.49,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 136.17,
    y: 143.28,
    width: 947.42,
    height: 528.97,
    rx: 12.49,
    ry: 12.49,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 136.17,
    y: 143.28,
    width: 947.42,
    height: 528.97,
    rx: 12.49,
    ry: 12.49,
    fill: "#5a5773",
    opacity: 0.04
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29,175.83H198.49a4.81,4.81,0,0,0-4.81,4.81V201H1141.1V180.64A4.81,4.81,0,0,0,1136.29,175.83Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#5a5773"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4856ee63-6c9d-47e3-9e79-3603b2312fc4",
    "data-name": "buttons"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 155.09,
    cy: 149.78,
    r: 6.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.59,
    cy: 149.78,
    r: 6.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.09,
    cy: 149.78,
    r: 6.5,
    fill: "#fff"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 199.59,
    y: 279.47,
    width: 790,
    height: 304,
    rx: 10.19,
    ry: 10.19,
    fill: "#4b59f7",
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 272.39,
    y: 298.35,
    width: 790,
    height: 304,
    rx: 10.19,
    ry: 10.19,
    transform: "translate(-45.85 -55.44) rotate(1.46)",
    fill: "#fff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 337.02,
    y1: 314.26,
    x2: 887.34,
    y2: 328.25,
    fill: "#f4f4f7",
    stroke: "#5a5773",
    strokeMiterlimit: 10,
    opacity: 0.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 335.93,
    y1: 357.25,
    x2: 886.25,
    y2: 371.24,
    fill: "#f4f4f7",
    stroke: "#5a5773",
    strokeMiterlimit: 10,
    opacity: 0.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 334.84,
    y1: 400.23,
    x2: 885.16,
    y2: 414.22,
    fill: "#f4f4f7",
    stroke: "#5a5773",
    strokeMiterlimit: 10,
    opacity: 0.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 333.74,
    y1: 443.22,
    x2: 884.07,
    y2: 457.21,
    fill: "#f4f4f7",
    stroke: "#5a5773",
    strokeMiterlimit: 10,
    opacity: 0.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 383.76,
    y1: 432.82,
    x2: 382.37,
    y2: 487.47,
    fill: "none",
    stroke: "#5a5773",
    strokeMiterlimit: 10,
    strokeDasharray: 12,
    opacity: 0.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 332.65,
    y1: 486.21,
    x2: 882.97,
    y2: 500.19,
    fill: "#f4f4f7",
    stroke: "#5a5773",
    strokeMiterlimit: 10,
    opacity: 0.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 444.61,
    y1: 489.05,
    x2: 446.68,
    y2: 407.58,
    fill: "none",
    stroke: "#5a5773",
    strokeMiterlimit: 10,
    strokeDasharray: 12,
    opacity: 0.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M866.16,439.76c-9.81.85-19.39-4.65-25.26-10.43-6.08-6-10.49-13.38-14.75-20.56-1.35-2.27-2.75-4.61-4.16-6.87-7.43-11.78-14.85-19.7-23.34-24.93a44.44,44.44,0,0,0-9.93-4.54,7,7,0,0,1-1.41,2.14,7,7,0,0,1-4.9,2.15h-.33a7,7,0,0,1-6.75-6.07,30.45,30.45,0,0,0-9.21,1.89c-8.73,3.29-15.36,10.36-21.39,17.33-7.3,8.42-14.34,17.25-20.9,26.26q-2,2.73-4,5.49c-7.12,9.94-14.48,20.21-24,28.24-12.78,10.84-28.15,15.51-41.12,12.5-15.56-3.61-26.69-17.36-34.64-28.94-1-1.5-2-3-3.08-4.53-7.42-11-15.09-22.37-26.41-29-14.91-8.75-35.5-7.24-49,3.57-6.58,5.27-11.52,12.43-16.31,19.35-1.64,2.38-3.34,4.84-5.09,7.2-9,12.09-18.07,18.65-27.85,20.07a52.94,52.94,0,0,1-11.67,0c-2.58-.18-5.25-.38-7.86-.31a37.79,37.79,0,0,0-31.57,19.67L439.85,527l432.31,11,2.42-95.23a6,6,0,0,1-8.42-3Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#4b59f7",
    opacity: 0.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 511.95,
    y1: 355.58,
    x2: 508.52,
    y2: 490.68,
    fill: "none",
    stroke: "#5a5773",
    strokeMiterlimit: 10,
    strokeDasharray: 12,
    opacity: 0.2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 572.24,
    y1: 407.27,
    x2: 570.08,
    y2: 492.24,
    fill: "none",
    stroke: "#5a5773",
    strokeMiterlimit: 10,
    strokeDasharray: 12,
    opacity: 0.2
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 632.2,
    y1: 417.24,
    x2: 630.26,
    y2: 493.77,
    fill: "none",
    stroke: "#5a5773",
    strokeMiterlimit: 10,
    strokeDasharray: 12,
    opacity: 0.2
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 690.39,
    y1: 348.75,
    x2: 686.67,
    y2: 495.2,
    fill: "none",
    stroke: "#5a5773",
    strokeMiterlimit: 10,
    strokeDasharray: 12,
    opacity: 0.2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 749.61,
    y1: 343.64,
    x2: 745.72,
    y2: 496.71,
    fill: "none",
    stroke: "#5a5773",
    strokeMiterlimit: 10,
    strokeDasharray: 12,
    opacity: 0.2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 815.2,
    y1: 401.19,
    x2: 812.72,
    y2: 498.41,
    fill: "none",
    stroke: "#5a5773",
    strokeMiterlimit: 10,
    strokeDasharray: 12,
    opacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M788.12,365.68a7,7,0,0,0-5-1.95,7,7,0,0,0-6.79,5.93,6.79,6.79,0,0,0-.08,1.2c0,.27,0,.54.06.8a7,7,0,0,0,2.09,4.11,6.87,6.87,0,0,0,4.66,2h.33a7,7,0,0,0,4.91-2.14,7.17,7.17,0,0,0,1.41-2.14,6.91,6.91,0,0,0,.5-1.95,5.55,5.55,0,0,0,0-.91A7,7,0,0,0,788.12,365.68Zm-.35,7.2a4.54,4.54,0,0,1-.91,1.31,5,5,0,0,1-8.51-2.58,4.16,4.16,0,0,1-.09-.79,4.8,4.8,0,0,1,.12-1.2,5,5,0,0,1,4.78-3.9h.23a5,5,0,0,1,4.87,4.89c0,.1,0,.21,0,.31A4.65,4.65,0,0,1,787.77,372.88Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#4b59f7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 815.26,
    cy: 399.88,
    r: 6,
    fill: "#4b59f7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M778.26,370.82a4.16,4.16,0,0,0,.09.79c-.68,0-1.36,0-2,.05a30.58,30.58,0,0,0-9.22,1.89c-8.73,3.29-15.36,10.36-21.4,17.33-7.3,8.41-14.34,17.25-20.91,26.25-1.33,1.82-2.64,3.66-4,5.5-7.13,9.94-14.49,20.2-24,28.24-12.79,10.83-28.17,15.5-41.15,12.49C640.13,459.76,629,446,621,434.42c-1-1.49-2.06-3-3.08-4.53-7.43-11-15.11-22.37-26.43-29-14.91-8.75-35.52-7.24-49,3.57C536,409.72,531,416.88,526.21,423.8c-1.65,2.38-3.35,4.85-5.1,7.2-9,12.09-18.08,18.65-27.86,20.07a53.57,53.57,0,0,1-11.67,0,76.47,76.47,0,0,0-7.87-.31,37.72,37.72,0,0,0-32.79,22.12l-1.84-.8a39.8,39.8,0,0,1,34.57-23.32,74.56,74.56,0,0,1,8.08.32,52.05,52.05,0,0,0,11.23,0c9.23-1.33,17.91-7.64,26.54-19.28,1.73-2.33,3.42-4.78,5.06-7.15,4.87-7,9.91-14.31,16.71-19.77a46.11,46.11,0,0,1,51.26-3.73c11.72,6.87,19.53,18.43,27.09,29.62,1,1.5,2,3,3.07,4.51,7.75,11.28,18.55,24.67,33.46,28.12,12.36,2.87,27.09-1.64,39.4-12.07,9.29-7.87,16.6-18,23.65-27.88,1.31-1.84,2.64-3.68,4-5.51,6.61-9,13.68-17.92,21-26.39,6.21-7.16,13-14.43,22.21-17.88a32.75,32.75,0,0,1,9.94-2c.67,0,1.36-.06,2,0A4.8,4.8,0,0,0,778.26,370.82Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#4b59f7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M873.11,439.44c-11.73,4.38-24.13-2.16-31.19-9.1-6.08-6-10.49-13.39-14.75-20.57-1.35-2.26-2.75-4.61-4.17-6.86-7.43-11.79-14.85-19.71-23.35-24.94a44.6,44.6,0,0,0-9.93-4.53c-.64-.21-1.29-.39-2-.56a4.65,4.65,0,0,0,.49-1.95c.66.17,1.31.36,2,.56a46.34,46.34,0,0,1,10.47,4.78c8.78,5.39,16.4,13.51,24,25.57,1.43,2.28,2.83,4.63,4.2,6.92,4.2,7.06,8.54,14.37,14.43,20.15,6.63,6.52,18.24,12.71,29.09,8.66Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#4b59f7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 394.64,
    y: 344.15,
    width: 20.4,
    height: 9,
    rx: 0.9,
    ry: 0.9,
    transform: "translate(-48.51 -48.8) rotate(1.46)",
    fill: "#4b59f7",
    opacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 393.54,
    y: 387.13,
    width: 20.4,
    height: 9,
    rx: 0.9,
    ry: 0.9,
    transform: "translate(-47.42 -48.76) rotate(1.46)",
    fill: "#4b59f7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 392.45,
    y: 430.12,
    width: 20.4,
    height: 9,
    rx: 0.9,
    ry: 0.9,
    transform: "translate(-46.33 -48.71) rotate(1.46)",
    fill: "#4b59f7",
    opacity: 0.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 473.1,
    width: 20.4,
    height: 9,
    rx: 0.9,
    ry: 0.9,
    transform: "translate(-45.24 -48.67) rotate(1.46)",
    fill: "#4b59f7",
    opacity: 0.5
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 390.27,
    y: 516.09,
    width: 20.4,
    height: 9,
    rx: 0.9,
    ry: 0.9,
    transform: "translate(-44.15 -48.63) rotate(1.46)",
    fill: "#4b59f7",
    opacity: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 428.1,
    y: 535.06,
    width: 20.4,
    height: 9,
    rx: 0.9,
    ry: 0.9,
    transform: "translate(-43.65 -49.59) rotate(1.46)",
    fill: "#4b59f7",
    opacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 491.58,
    y: 536.67,
    width: 20.4,
    height: 9,
    rx: 0.9,
    ry: 0.9,
    transform: "translate(-43.59 -51.2) rotate(1.46)",
    fill: "#4b59f7",
    opacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 555.48,
    y: 538.29,
    width: 20.4,
    height: 9,
    rx: 0.9,
    ry: 0.9,
    transform: "matrix(1, 0.03, -0.03, 1, -43.53, -52.82)",
    fill: "#4b59f7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 617.05,
    y: 539.86,
    width: 20.4,
    height: 9,
    rx: 0.9,
    ry: 0.9,
    transform: "translate(-43.47 -54.39) rotate(1.46)",
    fill: "#4b59f7",
    opacity: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 677.22,
    y: 541.39,
    width: 20.4,
    height: 9,
    rx: 0.9,
    ry: 0.9,
    transform: "translate(-43.41 -55.91) rotate(1.46)",
    fill: "#4b59f7",
    opacity: 0.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 733.63,
    y: 542.82,
    width: 20.4,
    height: 9,
    rx: 0.9,
    ry: 0.9,
    transform: "translate(-43.36 -57.35) rotate(1.46)",
    fill: "#4b59f7"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 793.1,
    y: 544.33,
    width: 20.4,
    height: 9,
    rx: 0.9,
    ry: 0.9,
    transform: "translate(-43.3 -58.86) rotate(1.46)",
    fill: "#4b59f7"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 859.69,
    y: 546.03,
    width: 20.4,
    height: 9,
    rx: 1.39,
    ry: 1.39,
    transform: "matrix(1, 0.03, -0.03, 1, -43.23, -60.55)",
    fill: "#4b59f7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.37,644.11a9.9,9.9,0,1,1-7,2.9,9.85,9.85,0,0,1,7-2.9m0-1.54A11.45,11.45,0,1,0,1049.82,654,11.44,11.44,0,0,0,1038.37,642.57Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#4b59f7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.3,657.38l.6-.8a3.18,3.18,0,0,0,2.19.91c1,0,1.79-.51,1.79-1.32s-.73-1.46-2.75-1.46v-.92c1.8,0,2.48-.6,2.48-1.38s-.61-1.15-1.5-1.15a2.93,2.93,0,0,0-1.89.77l-.64-.77a4,4,0,0,1,2.58-1c1.55,0,2.7.75,2.7,2.06,0,.92-.67,1.53-1.65,1.86v.05a2.15,2.15,0,0,1,1.92,2c0,1.42-1.34,2.28-2.94,2.28A3.87,3.87,0,0,1,1035.3,657.38Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#4b59f7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.66,644.78a9.9,9.9,0,1,1-7,2.9,9.84,9.84,0,0,1,7-2.9m0-1.54a11.45,11.45,0,1,0,11.45,11.45A11.44,11.44,0,0,0,1085.66,643.24Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#5a5773"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.81,653.49c0-.49,0-1.11.07-1.6h-.07c-.28.43-.6.86-.88,1.29l-2,2.61h5.41v1.05h-6.81V656l4.06-5.34h1.49v8.5h-1.24Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#5a5773"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.57,648.15a1.05,1.05,0,0,1,1.47,0l5.16,5.18a1,1,0,0,1,0,1.44l-5.08,5.1a1,1,0,0,1-1.48,0,1,1,0,0,1,0-1.47L1064,654l-4.43-4.38a1,1,0,0,1,0-1.48Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#5a5773"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.77,654A11.25,11.25,0,1,0,1062,642.77,11.24,11.24,0,0,0,1050.77,654Zm1.73,0a9.53,9.53,0,1,1,2.79,6.72A9.42,9.42,0,0,1,1052.5,654Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#5a5773"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 166.09,
    y: 189.05,
    width: 227.24,
    height: 23.85,
    rx: 3.86,
    ry: 3.86,
    fill: "#5a5773",
    opacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M764.69,795.76c-1.66-6-2.74-11.3-2.74-11.3s.07-6.6-3.08-11.45l-.06-1.65h0l-.47-12.2a41.53,41.53,0,0,1,2.83-6.51c2.06-3.92-.68-17.88-.68-17.88s-8.91-19.49-7.41-32.13-18.86-55.15-18.86-55.15a54.52,54.52,0,0,1,1.28-12.41,10.15,10.15,0,0,0,.14-2.6c0-.11,0-.2,0-.32,0,0,0,.07,0,.1-.59-8.27-7.74-23.55-7.74-23.55l-.26-29.63s3.51-17.62-4.22-40.78c-2.69-8.08-4.47-14.56-5.63-19.58-.13-.56-.26-1.11-.37-1.63,14-2.69,24.61-4.88,24.61-4.88s-9.45-33.75-15.18-39.5S716,448.4,716,448.4s-3.79-23.95.56-31.16,4.55-19.36,4.55-19.36,10.26-8.08,11.45-11.53,3.09-11.21,2.94-15.26-1.62-7.61-1.26-9.76-3.47-10.1-1.86-14a10.56,10.56,0,0,0,.56-3.72s0-.08,0-.11,0,0,0-.05a51.94,51.94,0,0,0-1.31-9.95,28.26,28.26,0,0,0-10.66-5.19l-.27-.9L720,325c-.36-.22-.71-.41-1.06-.58l-.06-.87-.23-3.45L720,312.3c2.72-13.65-15.39-15-15.39-15a9.45,9.45,0,0,0-5.29-4.28c-3.68-1.14.18,20.36,1.93,21.67,1.31,1,5.52,7.62,7.55,10.88h0l.32.53a9.42,9.42,0,0,0-.79.9l.87,4.67.13.71a19.72,19.72,0,0,0-2.69,5s3.44,3.5,2.94,7.57,1.36,9.05,1.45,9.32c-.2-.22-2.62-2.64-4.91-1.94s-8.7,2.89-8.7,2.89-4.81,1-4.33,2.09-3.08,5.88-3.08,5.88l-13.48-11.83c-.14-.36-.29-.72-.42-1.1a30.33,30.33,0,0,1-1.34-5.35,30.6,30.6,0,0,0,4.11-1.49,9,9,0,0,0,3.51-2.44c1.25-1.61,1.42-3.73,1.88-5.69.88-3.82,3-7.28,4.41-10.94A35.07,35.07,0,0,0,690.52,305a12.83,12.83,0,0,0-2.21-5.58c-2.24-2.84-6.13-3.88-9-6.1s-4.84-5.71-8.17-7.34c-3-1.46-6.6-1.14-9.9-.46A53.1,53.1,0,0,0,643,292.91c-1.85,1.19-3.88,2.57-6.08,2.26-1.88-.27-3.31-1.71-4.57-3.09,0-.06,0-.12.05-.18l-.15-.17a22.91,22.91,0,0,0-1.64,9.81q0,.78.12,1.56c0,.18,0,.36.05.54a3.38,3.38,0,0,1,0,.45v0a2.7,2.7,0,0,1-.07.69,5.06,5.06,0,0,1-1.15,1.81,10.42,10.42,0,0,0-1,1.48c0-.18.1-.36.16-.53a7.68,7.68,0,0,0-1.19,4.15,4.07,4.07,0,0,0,1.09,2.89,14.15,14.15,0,0,0,2.19,1.63,24.12,24.12,0,0,0-.22,4.35,25.12,25.12,0,0,0,13.08,21l.48,1.1c1.83,4.31,3.28,9.36,2.91,14.09,0,.35-.07.69-.12,1-.16.18-.31.37-.45.56h0s-21.47,1-26.7-3.35-12.33,11.67-12.33,11.67-7.64,1.79-9.23.36-10.57.19-10.57.19a19.45,19.45,0,0,0-13.61-4.38A39.64,39.64,0,0,0,564,357.7h0l-.24-.08h0a11.06,11.06,0,0,0-4.87-.43s-10.89-8.32-14.15-12.89-18.6-21.38-18.67-21.45L526,322l-.26-2.52a10.24,10.24,0,0,1-1.31.16q-.13-.37-.33-.87a48.16,48.16,0,0,0-3.39-7s-.12-3.2.78-4-.87-12.5-.87-12.5-10.37-21.88-18.26-4.94c0,0-15.7,11.37-1.69,23.36,0,0,5.5,2.4,6.34,4.44.55,1.33,2.53,5,3.86,7.46l.59,1.1-.15.13.28,2.08.11.81c-2.49,1.55-4.16,3.05-3.7,4.11a23.92,23.92,0,0,1,1.76,5.69s19.6,22.71,22.41,32.62c0,0,51.3,27.88,67.88,29.38l-2.28,15s-.54,9-.2,12.16-1.3,17.75-1.3,17.75-2,21.41-4.34,24.48-1.38,15.83-1.38,15.83a107.23,107.23,0,0,1-2.6,18.23c-2.11,8.18,0,18.12,0,18.12s-7.62,19.49,11.89,5.73c0,0,9.81-1,21.11-1.81,0,.37,0,.74,0,1.13,0,1.46.06,3,.11,4.7.27,11,.79,26.11,1.72,37.53,1.66,20.19,9.36,60,9.36,60l.77,20.11a27.34,27.34,0,0,0-.35,5.77,37.36,37.36,0,0,0,6.19,19.92l2.06,13.36s4,8.69,4.22,14a7.35,7.35,0,0,1-.1,1.29,9.22,9.22,0,0,0-.1,2.06c0,6.1,4.26,20.53,4.26,20.53s.79,14.68,3,15.45c1.91.66-2.19,8.56-3.41,10.84,0-.14-.07-.28-.1-.42l-.25.45a10.32,10.32,0,0,0-.55,3.74,5.35,5.35,0,0,0,2.64,5.07c4.28,2.4,6.61,4.44,3.09,5.43a38.39,38.39,0,0,0-3.84,1l-.2-.48A2.34,2.34,0,0,0,648.2,771c-.06,1.07.36,2.63,1.5,4.93,3.82,7.74,6.38,10.63,6.38,10.63l1.68-.26a8.41,8.41,0,0,1-.91,1.86,7,7,0,0,1-2.4,2.3,7.66,7.66,0,0,1-3,1.15,8.47,8.47,0,0,0-6.12,3.27c-2.08,2.92-3.31,6.84,1.16,10.07l15.94,4.82s27.19,2.48,25.52-3.54-2.74-11.3-2.74-11.3a24.13,24.13,0,0,0-2.61-10.68,12.19,12.19,0,0,0-1-1.55l.95-.15s1.47-13.49,4-16.14c.58-.62.7-1.07.55-1.42.24-.74-.46-1.14-1.36-1.35-.06.18-.12.35-.17.54A12.65,12.65,0,0,0,683,764s-1.15-7,1.61-9.66a2.67,2.67,0,0,0,.47-2.11,11.38,11.38,0,0,0-.4-2.85s-.06.11-.1.17c-1.69-6.32-6.95-16.27-6.95-16.27s-.46-6.38,1.2-9-1.56-34.7-1.56-34.7.06-15.57-2.2-22.73S676.84,651,676.84,651s0-.17-.07-.46a.49.49,0,0,0,.05-.11s-.13-1-.35-2.44c0,0,0,.1,0,.15-.6-4.1-1.73-11.52-2.48-14.94-1.07-4.86-.87-28.33-.87-28.33l3.58-10.16,7.7,17,8.36,22.71s3.9,4.71,4.17,9.63c0,.24,0,.48,0,.72,0,.53,0,1,0,1.54a13.69,13.69,0,0,0,2.6,8.11s2.4,10.78,5.58,13.43,3.4,8,3.4,8,4.34,15.61,6.21,18.31c1.57,2.28,1.9,8.69,2,10.65h0c0,.36,0,.57,0,.57s.74,5.61.9,10.35c0,.58,0,1.15,0,1.68,0,0,0-.08,0-.12a16.65,16.65,0,0,1-.31,3.85c0,.06,0,.14-.06.22,0-.27,0-.54,0-.8a40.35,40.35,0,0,0-.75,9.86c.12,5.67,1.24,12.34,4.82,16.15,6.2,6.59,9.91,5.59,9.91,5.59s-2.53,8.63-6,10.47a1.78,1.78,0,0,0-.36.25c0-.16-.08-.33-.11-.49a4.13,4.13,0,0,0-.91,3.21c-.11,3.76,2.49,9.75,4.84,12.46a7.05,7.05,0,0,0,3,1.62,5.07,5.07,0,0,1-.54.36,10.62,10.62,0,0,1-1.19.62,5.76,5.76,0,0,1-1.78.54,8.42,8.42,0,0,0-6.11,3.27c-2.08,2.91-3.32,6.83,1.15,10.06l15.95,4.82S766.36,801.78,764.69,795.76Z",
    transform: "translate(-57.5 -38.62)",
    fill: "url(#9599d617-6377-49c4-b753-a452dc901e54)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M661.73,809.8,646.3,805c-4.33-3.24-3.15-7.16-1.13-10.07a8.1,8.1,0,0,1,5.91-3.27,7.14,7.14,0,0,0,2.87-1.14,6.84,6.84,0,0,0,2.33-2.3,11.33,11.33,0,0,0,1.51-5.95s16.53-5.54,21.29-.82a12.31,12.31,0,0,1,2.14,2.89A24.81,24.81,0,0,1,683.77,795s1.05,5.28,2.67,11.3S661.73,809.8,661.73,809.8Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#2d293d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M736,799.43l-15.44-4.84c-4.33-3.24-3.14-7.16-1.13-10.07a8.05,8.05,0,0,1,5.91-3.26,5.42,5.42,0,0,0,1.72-.54,9.43,9.43,0,0,0,1.16-.61c4.17-2.51,3.83-8.25,3.83-8.25s16.53-5.54,21.3-.82a12.17,12.17,0,0,1,1.68,2.11c3.06,4.85,3,11.47,3,11.47s1.06,5.29,2.67,11.3S736,799.43,736,799.43Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#2d293d"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M679.08,781.41a12.31,12.31,0,0,1,2.14,2.89h0l-24.94,3.87a11.33,11.33,0,0,0,1.51-5.95S674.32,776.69,679.08,781.41Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M755,773.15l.18,4.69c-3.64,6.57-22.55,5.89-28.15,2.88a9.43,9.43,0,0,0,1.16-.61c4.17-2.51,3.83-8.25,3.83-8.25s16.53-5.54,21.3-.82A12.17,12.17,0,0,1,755,773.15Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M757.2,752.82a41.78,41.78,0,0,0-2.73,6.5l.65,16.82c-4,7.19-26.23,5.7-29.36,2s-6.7-13.6-3.36-15.44,5.78-10.45,5.78-10.45-3.59,1-9.6-5.6-4.89-21.78-4-25.44-.62-15.76-.62-15.76-.11-8.52-1.92-11.22-6-18.32-6-18.32-.2-5.33-3.29-8-5.42-13.44-5.42-13.44a14,14,0,0,1-2.48-9.07c.43-5.35-4.05-10.94-4.05-10.94l-8.12-22.71-7.48-17-3.45,10.16s-.16,23.46.88,28.32,2.82,17.81,2.82,17.81-3.94,8.68-1.74,15.84,2.15,22.74,2.15,22.74,3.16,32.08,1.55,34.7-1.14,9-1.14,9,9.45,18.4,6.78,21.06-1.55,9.65-1.55,9.65,6-.23,3.5,2.43-3.85,16.14-3.85,16.14l-25.63,4s-2.48-2.89-6.19-10.64.37-7.05,3.76-8,1.15-3-3-5.43-2-8.24-2-8.24,5.77-10.67,3.61-11.44-2.94-15.45-2.94-15.45-4.93-17.3-4-22-4-15.84-4-15.84l-2-13.36C630.5,663.23,633,651,633,651l-.8-20.66s-7.5-39.8-9.13-60c-1-12.94-1.57-30.62-1.81-41.66-.14-6.2-.19-10.3-.19-10.3l91.62-13.12s.07,4.25,2.19,13.6c1.13,5,2.86,11.5,5.48,19.59,7.5,23.16,4.13,40.78,4.13,40.78l.29,29.63s8.85,19.49,7.41,26.37A56.78,56.78,0,0,0,731,647.63s19.76,42.53,18.33,55.17,7.2,32.13,7.2,32.13S759.18,748.9,757.2,752.82Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#575988"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M700.34,643.91l27.86-4.81S713,655.9,700.34,643.91Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.05
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M723.1,611.9s1.34,9.86-4.59,13.82C718.51,625.72,729.31,623.6,723.1,611.9Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M720.17,580.45s-22.67,20.17-31.24,18.9S720.17,580.45,720.17,580.45Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M666,654.29S648.36,659,648.1,666.17,666,654.29,666,654.29Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M673.31,742.93s-24.94,5.65-17.69,8.57,19.07,5,19.07,5S682.79,756.64,673.31,742.93Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.05
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M650.74,756.76a5,5,0,0,1-2.43-3.55l-.24.46s-2.13,5.84,2,8.24c.48.27.92.54,1.35.81.73-.17,1.54-.3,2.3-.53C657.14,761.21,654.89,759.16,650.74,756.76Z",
    transform: "translate(-57.5 -38.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683,753.82c.67-.67.58-2.3.08-4.39-1.07,1.7-1.25,4.27-1.19,6.22A4.89,4.89,0,0,1,683,753.82Z",
    transform: "translate(-57.5 -38.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.1,648a29,29,0,0,0-1.4,7.89,31.11,31.11,0,0,1,1.74-5.46S675.31,649.52,675.1,648Z",
    transform: "translate(-57.5 -38.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.19,634.64a10,10,0,0,0,.15-2.34c-.26,1.61-.42,3.09-.53,4.39C731.92,636,732.05,635.34,732.19,634.64Z",
    transform: "translate(-57.5 -38.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.41,723.75c.32-.53.45-2.3.45-4.75a16.13,16.13,0,0,0-1,6A5.71,5.71,0,0,1,677.41,723.75Z",
    transform: "translate(-57.5 -38.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.23,763.7c-1.57,4.86-2.43,13.19-2.43,13.19l-25.63,4S653.69,778,650,770.23c-.32-.68-.59-1.29-.8-1.85-1.51.77-2.06,2.39.15,7,3.71,7.75,6.18,10.64,6.18,10.64l25.63-4s1.4-13.49,3.86-16.15C686.21,764.59,685.38,764,684.23,763.7Z",
    transform: "translate(-57.5 -38.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.74,726.77s.78,14.69,2.94,15.46h0c1-2.48,1.61-4.81.64-5.15-2.16-.77-2.94-15.46-2.94-15.46s-4.93-17.29-4-22-4-15.84-4-15.84l-2-13.35c-8.17-12.91-5.66-25.16-5.66-25.16l-.8-20.65s-7.5-39.8-9.13-60c-1-12.93-1.57-30.62-1.81-41.66,0-2-.08-3.76-.11-5.25l-.73.1s0,4.1.18,10.3c.25,11,.77,28.72,1.82,41.65,1.63,20.2,9.13,60,9.13,60L633,650.4s-2.51,12.25,5.66,25.16l2,13.36s4.91,11.11,4,15.83S648.74,726.77,648.74,726.77Z",
    transform: "translate(-57.5 -38.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.41,772.4a24.66,24.66,0,0,1-4.47-9.95c-2.54,2.47.84,11.56,3.81,15.1,3.13,3.72,25.36,5.21,29.35-2l-.16-4.06C749.41,777.44,729.36,775.92,726.41,772.4Z",
    transform: "translate(-57.5 -38.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.84,747.1a41.78,41.78,0,0,0-2.73,6.5l.11,3c.44-1.11,1.08-2.59,2-4.35a13,13,0,0,0,.73-5.31C757.89,747,757.87,747.05,757.84,747.1Z",
    transform: "translate(-57.5 -38.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.92,751.65a42.06,42.06,0,0,0,1.9-5.14s-3.59,1-9.6-5.6c-4.37-4.8-5-14.15-4.61-20.29-.93,3.66-2.05,18.84,4,25.43C722.5,750.36,725.39,751.43,726.92,751.65Z",
    transform: "translate(-57.5 -38.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714,704.86a116.39,116.39,0,0,1,.91,12.6,16.38,16.38,0,0,1,.36-2c.93-3.66-.62-15.75-.62-15.75s-.11-8.53-1.92-11.23-6-18.32-6-18.32-.2-5.32-3.29-8S698,648.75,698,648.75a13.93,13.93,0,0,1-2.48-9.07c.43-5.35-4-10.93-4-10.93L683.33,606l-7.48-17L672.4,599.2s0,1.26,0,3.24l2.8-8.25,7.48,17,8.13,22.72s4.48,5.59,4,10.93a14,14,0,0,0,2.48,9.08s2.34,10.78,5.42,13.44,3.3,8,3.3,8,4.22,15.62,6,18.32S714,704.86,714,704.86Z",
    transform: "translate(-57.5 -38.62)"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M716.8,312.43l-1.3,7.84.23,3.45.16,2.55-8.84,1.26-1.07-1.8h0c-2-3.26-6.05-9.89-7.32-10.89-1.7-1.31-5.46-22.81-1.89-21.67a9.34,9.34,0,0,1,5.12,4.29S719.42,298.79,716.8,312.43Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#ffcdd3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M715.89,326.27l-8.84,1.26-1.07-1.8h0a7.85,7.85,0,0,1,9.75-2Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M718.3,330.4l-11.61,3.16-.32-1.73-.84-4.67s4.4-6.36,11.28-2l.68,2.37Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#dce6f2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M527.86,320.55l-12.24,7.2s-.52-1-1.23-2.32c-1.28-2.45-3.2-6.14-3.74-7.46-.82-2-6.14-4.46-6.14-4.46-13.57-12,1.61-23.35,1.61-23.35,7.61-16.93,17.68,5,17.68,5s1.72,11.67.85,12.5-.75,4-.75,4a46.85,46.85,0,0,1,3.29,7C527.63,319.83,527.86,320.55,527.86,320.55Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#ffcdd3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M527.86,320.55l-12.24,7.2s-.52-1-1.23-2.32c1.71-1.54,7.77-6.86,9.84-6.71a15.89,15.89,0,0,0,3,0C527.63,319.83,527.86,320.55,527.86,320.55Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M529.28,324.29l-13.78,7.46-.4-3-.28-2.08s7.88-7.29,10.29-7.12a12.87,12.87,0,0,0,3.67-.15l.26,2.53Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#dce6f2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M684.72,365.38s-61,9.27-49.7,5.11c7.87-2.9,10.85-8.09,11.29-13.74.36-4.73-1-9.78-2.82-14.09a61,61,0,0,0-5.91-10.86S683.43,304.23,675,328a37.34,37.34,0,0,0-2.23,11.2,31.14,31.14,0,0,0,1.63,11.19A33.47,33.47,0,0,0,684.72,365.38Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#ffcdd3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M675,328a37.34,37.34,0,0,0-2.23,11.2c-4.27,3.88-9.12,3.82-15.33,4.06-4.78.18-10,1.54-13.92-.61a61,61,0,0,0-5.91-10.86S683.43,304.23,675,328Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 598.16,
    cy: 280.96,
    r: 25.36,
    fill: "#ffcdd3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M684.72,365.38s-61,9.27-49.7,5.11c7.87-2.9,10.85-8.09,11.29-13.74,2.93-3.42,9-6,12.85-7.46a18.4,18.4,0,0,1,11.1-.61,15.3,15.3,0,0,1,4.11,1.72A33.47,33.47,0,0,0,684.72,365.38Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M718.3,330.4l-11.61,3.16-.32-1.73a10.37,10.37,0,0,1,11.12-4.29Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M529.28,324.29l-13.78,7.46-.4-3c4.91-3.16,13.22-6.53,13.94-6.82Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M714.9,518.85c-23.58,4.66-57.17,10.84-62.59,9.41-4.5-1.18-18.69-.49-31,.41-.14-6.2-.19-10.3-.19-10.3l91.62-13.12S712.78,509.5,714.9,518.85Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M738.36,512.37s-77.63,16.42-86.12,14.19-51.43,2.19-51.43,2.19c-18.88,13.73-11.52-5.74-11.52-5.74s-2.09-9.94-.06-18.12a111,111,0,0,0,2.5-18.22s-.92-12.76,1.31-15.83,4.17-24.47,4.17-24.47,1.57-14.57,1.24-17.75.17-12.16.17-12.16l2.19-15c-16-1.52-65.74-29.46-65.74-29.46-2.73-9.92-21.73-32.64-21.73-32.64a24.24,24.24,0,0,0-1.71-5.69c-1.41-3.36,17.49-10.91,17.49-10.91s14.94,16.91,18.1,21.48,13.72,12.9,13.72,12.9a10.53,10.53,0,0,1,4.71.44,1.36,1.36,0,0,1,.25.07h0a38.36,38.36,0,0,1,9.75,5.11c7.64-.72,13.17,4.4,13.17,4.4s8.68-1.61,10.23-.18,8.94-.34,8.94-.34,6.85-16.05,11.92-11.66,25.85,3.38,25.85,3.38c2.63-3.79,9.26-6.69,13.42-8.21a18.4,18.4,0,0,1,11.1-.61,14.37,14.37,0,0,1,4.47,2l13.08,11.86s3.44-4.82,3-5.87,4.19-2.08,4.19-2.08,6.1-2.16,8.42-2.88,4.56,1.72,4.75,1.94c-.08-.27-1.88-5.36-1.41-9.32s-2.85-7.57-2.85-7.57c6.75-18.6,24.16-3.91,24.16-3.91s2.3,9.93.74,13.83,2.16,11.86,1.82,14,1.07,5.72,1.23,9.76S730.18,383,729,386.49,718,398,718,398s-.17,12.16-4.37,19.35-.51,31.16-.51,31.16,5,18.57,10.53,24.33S738.36,512.37,738.36,512.37Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#656691"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M619.05,376.65s-2.61-6.94-4.77-7.49a50.66,50.66,0,0,1-6.28-2.53l1.27-2.68s8.09,1.89,9.45,4.18S619.05,376.65,619.05,376.65Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M575.66,362.75c-.35,2.15-19.22,4.79-19.22,4.79l9.21-10h0l.24.08h0A38.36,38.36,0,0,1,575.66,362.75Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 462.2,
    cy: 297.02,
    r: 1.7,
    fill: "#575988"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 464.51,
    cy: 300.34,
    r: 1.7,
    fill: "#575988"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 466.76,
    cy: 303.4,
    r: 1.7,
    fill: "#575988"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 469.13,
    cy: 306.72,
    r: 1.7,
    fill: "#575988"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.83,
    cy: 298.81,
    r: 1.39,
    fill: "#575988"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 670.16,
    cy: 301.94,
    r: 1.39,
    fill: "#575988"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 670.47,
    cy: 305.07,
    r: 1.39,
    fill: "#575988"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M621.38,434.35c-.21-.25,50.12,58.52,86,22.06C707.42,456.41,648.85,466.66,621.38,434.35Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M595,466.92s28.75-.32,32.07,7.82l.33,8.6a5.48,5.48,0,0,1-5.34.21c-3-1.46-20.66-9.61-26.62-5.13Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M595.55,466.9s27.5-.31,30.67,7.46l.32,8.19a5.27,5.27,0,0,1-5.11.2c-2.83-1.38-19.76-9.16-25.46-4.88Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#656691"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M608.29,404a92.63,92.63,0,0,0,11.88,18.67,74.82,74.82,0,0,0,18.09,16.18S608.93,407.88,608.29,404Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M597.61,370.94s5.59,20.5,18.21,27.05Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M590.35,373.31c-.14-.38-3.63,16.52,16.9,25C607.25,398.32,598.57,395.74,590.35,373.31Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M715.23,354.61c-.32,0,10.21,6.16,13.11,9.09C728.34,363.7,721.28,354,715.23,354.61Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M649.7,342.82c.41,1.29.91,2.7,2.11,3.34a5.16,5.16,0,0,0,2.41.44c7.74.19,15.79.22,22.82-3a8.62,8.62,0,0,0,3.4-2.45c1.21-1.6,1.37-3.72,1.81-5.68.85-3.82,2.86-7.28,4.26-10.94a36.12,36.12,0,0,0,1.76-19.42,13,13,0,0,0-2.15-5.58c-2.16-2.85-5.94-3.89-8.74-6.11s-4.68-5.72-7.91-7.35c-2.91-1.47-6.39-1.15-9.58-.48A50.22,50.22,0,0,0,642.3,293c-1.79,1.19-3.75,2.57-5.88,2.25-1.87-.27-3.27-1.78-4.52-3.19a23.65,23.65,0,0,0-1.47,11.11,4.93,4.93,0,0,1,0,1.67,5.06,5.06,0,0,1-1.11,1.8c-1.82,2.29-2.88,5.83-.91,8,.86.94,2.14,1.42,3,2.38,1.5,1.73,1.12,4.31,1.17,6.59a3.37,3.37,0,0,0,.65,2.22,3.28,3.28,0,0,0,3.15.63,8.47,8.47,0,0,1,3.32-.45,5.49,5.49,0,0,1,3,2.12C646.41,332.48,648,337.41,649.7,342.82Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#2d293d"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M681.21,339.14a8.56,8.56,0,0,1-3.39,2.44c-7,3.25-15.08,3.22-22.83,3a5.33,5.33,0,0,1-2.41-.44c-1.19-.64-1.7-2.06-2.11-3.35-1.7-5.4-3.29-10.34-7-14.74a5.54,5.54,0,0,0-3-2.11,8.63,8.63,0,0,0-3.32.44,3.3,3.3,0,0,1-3.16-.62,3.46,3.46,0,0,1-.65-2.23c-.05-2.28.33-4.86-1.16-6.58-.84-1-2.12-1.44-3-2.39a5,5,0,0,1-.68-5.06c-1.27,2.2-1.75,5-.1,6.8.85.94,2.14,1.42,3,2.39,1.5,1.72,1.12,4.3,1.17,6.58a3.37,3.37,0,0,0,.65,2.22,3.28,3.28,0,0,0,3.15.63,8.66,8.66,0,0,1,3.32-.45,5.49,5.49,0,0,1,3,2.12c3.75,4.4,5.33,9.33,7,14.74.41,1.29.91,2.7,2.11,3.35a5.28,5.28,0,0,0,2.41.44c7.74.18,15.79.21,22.82-3a8.7,8.7,0,0,0,3.4-2.44,7.05,7.05,0,0,0,1-2.1C681.37,338.9,681.3,339,681.21,339.14Z",
    transform: "translate(-57.5 -38.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.49,304.11a3.59,3.59,0,0,0,.72-1.31,4.63,4.63,0,0,0,0-1.66,23.48,23.48,0,0,1,.83-9.21l-.15-.17a23.66,23.66,0,0,0-1.47,11.11A6.5,6.5,0,0,1,630.49,304.11Z",
    transform: "translate(-57.5 -38.62)"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M645.77,358.35s31.81,3,34.48-1.89",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M706.8,342.88s17.59-.65,21.71,5.79",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.41,677s5.93,7.75-2.74,19.46-15.81,21.59-12.92,28.89c0,0,13.08-21.74,23.72-22.05S1103.12,690.06,1091.41,677Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#4b59f7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.41,677a9.21,9.21,0,0,1,1.21,2.43c10.39,12.2,15.92,23.59,5.94,23.87-9.3.27-20.46,16.9-23.13,21.09a9.82,9.82,0,0,0,.32,1s13.08-21.74,23.72-22.05S1103.12,690.06,1091.41,677Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.44,686.87c0,2.73-.31,4.94-.69,4.94s-.68-2.21-.68-4.94.38-1.44.76-1.44S1102.44,684.14,1102.44,686.87Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#ffd037"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.22,690.13c-2.4,1.3-4.49,2.09-4.67,1.76s1.62-1.66,4-3,1.45-.36,1.64,0S1108.61,688.82,1106.22,690.13Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#ffd037"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.09,677s-5.93,7.75,2.73,19.46,15.82,21.59,12.93,28.89c0,0-13.08-21.74-23.72-22.05S1048.38,690.06,1060.09,677Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#4b59f7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.09,677a9.21,9.21,0,0,0-1.21,2.43c-10.39,12.2-15.92,23.59-5.94,23.87,9.3.27,20.45,16.9,23.13,21.09a9.82,9.82,0,0,1-.32,1s-13.08-21.74-23.72-22.05S1048.38,690.06,1060.09,677Z",
    transform: "translate(-57.5 -38.62)",
    opacity: 0.1
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.06,686.87c0,2.73.31,4.94.69,4.94s.68-2.21.68-4.94-.38-1.44-.76-1.44S1049.06,684.14,1049.06,686.87Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#ffd037"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.28,690.13c2.4,1.3,4.49,2.09,4.67,1.76s-1.62-1.66-4-3-1.46-.36-1.64,0S1042.88,688.82,1045.28,690.13Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#ffd037"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1018.24,
    cy: 736.53,
    rx: 62,
    ry: 9.51,
    fill: "#4b59f7",
    opacity: 0.1
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.66,714.89l-.3,2.42-.41,3.42-.17,1.43-.42,3.42-.18,1.43-.42,3.41-4.74,38.9c-.43,3.47-6.1,6.18-12.94,6.18h-24.66c-6.85,0-12.51-2.71-12.93-6.18l-4.76-38.9-.41-3.41-.17-1.43-.43-3.42-.17-1.43-.42-3.42-.29-2.42c-.24-2,2.83-3.62,6.7-3.62H1101C1104.83,711.27,1107.91,712.92,1107.66,714.89Z",
    transform: "translate(-57.5 -38.62)",
    fill: "#65617d"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1049.86 678.69 1049.44 682.11 987.04 682.11 986.63 678.69 1049.86 678.69",
    fill: "#9d9cb5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "1049.27 683.53 1048.86 686.96 987.64 686.96 987.22 683.53 1049.27 683.53",
    fill: "#9d9cb5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "1048.67 688.38 1048.26 691.8 988.23 691.8 987.81 688.38 1048.67 688.38",
    fill: "#9d9cb5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg-2.882a2cd55b0d7b00d26fa8b75df947a2.svg";
export { ForwardRef as ReactComponent };